<template>
  <div class="metrics-section">
    <div class="metric" v-for="(metric, index) in metrics" :key="index">
      <div class="metric-title-row">
        <icon class="metric-icon" v-if="metric.icon" :glyph="metric.icon" />
        <span class="metric-title">{{ metric.label }}</span>
        <el-dropdown class="dropdown-button" trigger="click">
          <i class="el-icon-more"></i>

          <el-dropdown-menu>
            <el-dropdown-item icon="el-icon-aim">
              <a :href="`/push/campaign/create?project_id=${projectId}`">
                {{
                  $t(
                    'CustomerIntelligence_LifecycleReportingPage_Action_Target'
                  )
                }}
              </a>
            </el-dropdown-item>
            <el-dropdown-item
              icon="el-icon-info"
              @click.native="handleDetailsClick(metric.label)"
            >
              {{
                $t('CustomerIntelligence_LifecycleReportingPage_Action_Details')
              }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <span class="metric-value">
        <icon
          class="arrow-icon"
          :glyph="'arrow-' + (metric.up ? 'up' : 'down')"
          size="10"
          :class="'arrow-icon-' + (metric.up ? 'up' : 'down')"
        />
        {{ metric.value | formatMetric }}
      </span>
    </div>
    <el-dialog
      :visible="!!details"
      :close-on-click-modal="false"
      :show-close="true"
      :before-close="beforeClose"
      :modal-append-to-body="false"
      width="750px"
      :title="details"
    >
      {{ details }}
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MetricsBlock',
  data() {
    return { details: null }
  },
  props: {
    metrics: {
      type: Array,
      required: true
    }
  },
  filters: {
    formatMetric(value) {
      if (!value) return ''
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  computed: {
    projectId() {
      return this.$store.getters.projectId
    }
  },
  methods: {
    handleDetailsClick(title) {
      // do api request to get data
      // set data as selected data
      this.details = title
      console.log('Details clicked ' + title)
    },
    beforeClose() {
      this.details = null
    }
  }
}
</script>

<style scoped>
.metrics-section {
  display: flex;
  flex-wrap: wrap;
  margin-top: 32px;
}
.metric {
  flex: 0 0 calc(calc(100% / 3) - 50px);
  padding: 24px;
  border: 1px solid #ebeef5;
}

.metric-title-row {
  display: flex;
  align-items: center;
}

.metric-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.metric-title {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;

  display: flex;
  align-items: center;
  color: #4b515f;
}

.metric-value {
  margin-top: 20px;

  font-weight: 600;
  font-size: 24px;
  line-height: 30px;

  display: flex;
  align-items: center;
  color: #53aee6;
}
.dropdown-button {
  transform: rotate(90deg);
  margin-left: auto;
  cursor: pointer;
}
.arrow-icon {
  color: #1fca10;
  margin: 0 10px;
  cursor: pointer;
}
.arrow-icon-down {
  color: #ed1c25;
}
</style>



// WEBPACK FOOTER //
// src/modules/customer-intelligence/components/MetricsBlock.vue